<template>
  <div
    class="bar-container"
    :style="{ background: formItem.background_img_url }"
  >
    <div class="bar-title">
      <p class="title" v-if="formItem.title">{{ formItem.title }}</p>
      <span class="count"
        ><span class="big">{{ formItem.current_value }}</span
        >/{{ formItem.max_value }} {{ formItem.sub_title }}</span
      >
    </div>
    <div class="progress">
      <div class="progress-bar" :style="{width: barWidth}"></div>
    </div>
    <lottie 
      v-if="animShow" 
      class="anim" 
      :options="defaultOptions" 
      v-on:animCreated="handleAnimation"/>
  </div>
</template>
<script>
import Lottie from 'vue-lottie'
import animationData from '../../images/sahua0627.json';
export default {
  props: ["formItem"],
  components: { Lottie }, // Lottie
  data() {
      return {
          barWidth: 0,
          defaultOptions: {
            animationData: animationData,
            loop:false
          }, //loop:false
          animationSpeed: 1,
          anim: '',
          animShow: false
      }
  },
  // mounted() {
  //     setTimeout(this.setProgress, 1000)
  // },
  watch: {
    // 'formItem.current_value': {
    //   handler(newV, oldV) {
    //     setTimeout(this.setProgress, 1000)
    //   },
    //   immediate: true
    // },
    formItem: {
      handler(newV) {
        if (newV) {
          setTimeout(this.setProgress, 1000)
        }
      },
      immediate: true,
      deep: true,
    },

  },
  methods: {
      setProgress() {
          this.barWidth = String((Math.round(Number(this.formItem.current_value)/Number(this.formItem.max_value)*10000))/100)+'%';
          
          // 去掉巴西证件上传完成后的撒花动画
          let up = new URLSearchParams(location.search);
          let country = up.get('location_country');
          if (country === 'BR') {
            window.localStorage && window.localStorage.setItem("audit_is_finished", "true");
          }

          const audit_is_finished = window.localStorage && window.localStorage.getItem("audit_is_finished");
          if (this.formItem.current_value === this.formItem.max_value && audit_is_finished !== 'true') {
            this.animShow = true;
            // 撒花动作只做一次
            window.localStorage && window.localStorage.setItem("audit_is_finished", "true");
          }
          // console.log(this.barWidth)
      },
      handleAnimation(anim) {
        this.anim = anim;
        this.anim.addEventListener('complete', () => {
          // console.log('1234')
          this.anim.destroy();
          this.animShow = false;
        });
      },
  }
};
</script>
<style lang="scss" scoped>
.bar-container {
  // position: sticky;
  // top: 0;
  padding: 0.13rem 0.32rem 0.21rem 0.32rem;
}
.bar-title {
  display: flex;
  justify-content: space-between;
  .title {
    line-height: 0.42rem;
    font-size: 0.36rem;
    font-weight: 700;
    color: #333;
  }
  .count {
    font-size: 0.28rem;
    color: #999999;
    font-weight: 700;
    .big {
      font-size: 0.4rem;
      color: #ff7226;
      font-weight: 700;
    }
  }
}
.progress {
  width: 100%;
  height: 0.24rem;
  position: relative;
  margin-top: 0.2rem;
  background: #f3f4f5;
  border-radius: .12rem;
  .progress-bar {
      width: 0;
      height: 0.24rem;
      position: absolute;
      border-radius: .12rem;
      background-image: linear-gradient(270deg, #FFB200 0%, #FFDB00 100%);
      transition: width 2s ease;
  }
}
.anim {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1;
  width: 100vw !important;
  height: 100vh !important;
  // background: #ccc;
}
</style>


